import React from 'react'

import type { IconProps } from './types'

const HpvVaccine: React.FC<IconProps> = ({ size = 40, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#a)">
        <g clip-path="url(#b)">
          <path
            d="m23.29 22.134-3.567-3.566-1.132 1.134 3.564 3.565a.8.8 0 1 0 1.134-1.133"
            fill="#00626C"
          />
          <path
            d="M19.197 11.105a5.707 5.707 0 1 0-8.07 8.072 5.707 5.707 0 0 0 8.07-8.072m-.856 7.215a4.496 4.496 0 1 1-6.358-6.359 4.496 4.496 0 0 1 6.358 6.36"
            fill="#00AECD"
          />
          <path
            d="M15.162 19.637a4.497 4.497 0 1 0 0-8.993 4.497 4.497 0 0 0 0 8.993"
            fill="#E0F7FC"
          />
          <path
            d="M4.956 12.54v8.723a1.602 1.602 0 0 1-3.203 0V12.54z"
            fill="#B3EED5"
          />
          <path
            d="M4.956 13.779v7.483a1.602 1.602 0 0 1-3.203 0V13.78z"
            fill="#2ED69E"
          />
          <path
            d="M18.65 14.128a.52.52 0 0 0-.454-.258.47.47 0 0 0-.377.234.17.17 0 0 1-.123.085l-.405.052a.39.39 0 0 1-.385-.184 2 2 0 0 0-.681-.678.39.39 0 0 1-.182-.391l.059-.406a.15.15 0 0 1 .075-.107.413.413 0 0 0-.183-.774.4.4 0 0 0-.376.205.42.42 0 0 0 .003.42.14.14 0 0 1 .01.129l-.155.382a.39.39 0 0 1-.352.246 2 2 0 0 0-.833.197.39.39 0 0 1-.434-.07l-.148-.14a.2.2 0 0 1-.06-.166.563.563 0 1 0-.603.505.2.2 0 0 1 .155.089l.158.243a.4.4 0 0 1 .012.413 2.05 2.05 0 0 0-.245.914.39.39 0 0 1-.24.345l-.424.185a.15.15 0 0 1-.13-.007.424.424 0 1 0 .167.563.15.15 0 0 1 .106-.078l.416-.071a.39.39 0 0 1 .402.181 2 2 0 0 0 .677.677.39.39 0 0 1 .181.385l-.052.41a.16.16 0 0 1-.08.116.45.45 0 0 0 .213.84.49.49 0 0 0 .421-.263.45.45 0 0 0-.026-.424.16.16 0 0 1-.013-.14l.143-.371a.39.39 0 0 1 .345-.252c.242-.008.48-.06.704-.15a.39.39 0 0 1 .413.069l.428.4a.17.17 0 0 1 .052.141.48.48 0 0 0 .173.423.53.53 0 0 0 .53.057.483.483 0 0 0-.186-.912.17.17 0 0 1-.133-.076l-.315-.481a.39.39 0 0 1-.008-.421 2.04 2.04 0 0 0 .313-.994.39.39 0 0 1 .251-.345l.378-.146a.17.17 0 0 1 .149.015.473.473 0 0 0 .668-.617"
            fill="#00B16A"
          />
          <path
            d="M14.26 15.045a.366.366 0 1 0 0-.733.366.366 0 0 0 0 .733m1.549-.571a.296.296 0 1 0 0-.593.296.296 0 0 0 0 .592m.089 2.009a.26.26 0 1 0 0-.519.26.26 0 0 0 0 .52m-.505-1.016a.211.211 0 1 0 0-.422.211.211 0 0 0 0 .422m-.973.826a.206.206 0 1 0 0-.412.206.206 0 0 0 0 .412"
            fill="#fff"
          />
          <path
            d="M8.045 18.021a.22.22 0 0 0-.11.195.2.2 0 0 0 .1.163.07.07 0 0 1 .037.053l.022.174a.17.17 0 0 1-.079.166.84.84 0 0 0-.292.293.17.17 0 0 1-.168.078l-.175-.025a.06.06 0 0 1-.046-.032.178.178 0 1 0-.065.24.06.06 0 0 1 .055-.005l.165.066a.17.17 0 0 1 .106.152.9.9 0 0 0 .085.359.17.17 0 0 1-.03.186l-.06.064a.1.1 0 0 1-.072.027.242.242 0 1 0 .217.259.1.1 0 0 1 .039-.067l.104-.068a.17.17 0 0 1 .178-.005.9.9 0 0 0 .394.106.17.17 0 0 1 .148.103l.08.182a.06.06 0 0 1-.003.057.182.182 0 0 0 .248.248.18.18 0 0 0 .093-.164.18.18 0 0 0-.099-.157.06.06 0 0 1-.033-.045l-.031-.18a.17.17 0 0 1 .078-.172.9.9 0 0 0 .292-.292.17.17 0 0 1 .165-.078l.177.023a.07.07 0 0 1 .05.034.194.194 0 0 0 .361-.091.21.21 0 0 0-.113-.182.2.2 0 0 0-.182.012.07.07 0 0 1-.06.005l-.16-.062a.17.17 0 0 1-.109-.148.9.9 0 0 0-.065-.303.17.17 0 0 1 .03-.178l.173-.184a.07.07 0 0 1 .06-.023.21.21 0 0 0 .182-.074.23.23 0 0 0 .025-.229.208.208 0 0 0-.392.08.07.07 0 0 1-.033.058l-.208.136a.17.17 0 0 1-.18.003.9.9 0 0 0-.429-.134.17.17 0 0 1-.148-.109l-.063-.163a.07.07 0 0 1 .006-.063.203.203 0 0 0-.265-.288"
            fill="#00CB8A"
          />
          <path
            d="M8.282 20.069a.158.158 0 1 0 0-.316.158.158 0 0 0 0 .316m-.215-.697a.128.128 0 1 0 0-.256.128.128 0 0 0 0 .256m.88-.055a.112.112 0 1 0 0-.223.112.112 0 0 0 0 .223m-.438.197a.09.09 0 1 0 0-.182.09.09 0 0 0 0 .182m.35.416a.089.089 0 1 0 0-.177.089.089 0 0 0 0 .177"
            fill="#fff"
          />
          <path
            d="M3.025 15.252H1.753a.281.281 0 0 1 0-.562h1.272a.281.281 0 1 1 0 .562m-.557 1.192h-.715a.281.281 0 0 1 0-.562h.715a.281.281 0 1 1 0 .562m.557 1.192H1.753a.281.281 0 1 1 0-.562h1.272a.281.281 0 1 1 0 .562m-.557 1.192h-.715a.281.281 0 1 1 0-.563h.715a.281.281 0 0 1 0 .563m0 2.384h-.715a.281.281 0 1 1 0-.563h.715a.281.281 0 0 1 0 .563m.557-1.192H1.753a.281.281 0 1 1 0-.563h1.272a.281.281 0 0 1 0 .563"
            fill="#008599"
          />
          <path
            d="M6.92 11.828c.007-.263.279-.649.443-.86a.154.154 0 0 1 .243 0c.165.211.436.597.444.86a.565.565 0 1 1-1.13 0"
            fill="#F44D2C"
          />
          <path
            d="m14.523 2.633 1.087-1.088.704.704-1.087 1.088z"
            fill="#B3EED5"
          />
          <path
            d="M7.764 10.34a.281.281 0 0 1-.199-.481l1.557-1.557a.281.281 0 0 1 .398.398l-1.557 1.557a.28.28 0 0 1-.199.082"
            fill="#008599"
          />
          <path
            d="m15.202 4.295-.643.643-4.069 4.069c-.183.183-.49.172-.687-.024l-.963-.964c-.197-.197-.207-.504-.025-.687l4.723-4.722z"
            fill="#B3EED5"
          />
          <path
            d="M14.559 4.938 10.49 9.007c-.183.183-.49.172-.687-.024l-.963-.964c-.197-.196-.207-.504-.025-.687l2.394-2.394z"
            fill="#2ED69E"
          />
          <path
            d="M14.067 1.928a.458.458 0 0 0-.647.647l1.864 1.864a.458.458 0 0 0 .647-.647z"
            fill="#E0F8EE"
          />
          <path
            d="m11.899 6.246-.086.086a.095.095 0 0 1-.134 0l-.194-.193a.095.095 0 0 1 0-.134l.086-.086a.063.063 0 0 0 0-.09l-.086-.086a.095.095 0 0 1 0-.134l.194-.193a.095.095 0 0 1 .134 0l.086.086a.06.06 0 0 0 .045.018.06.06 0 0 0 .044-.018l.086-.086a.095.095 0 0 1 .135 0l.193.193a.095.095 0 0 1 0 .134l-.086.086a.07.07 0 0 0-.019.045.06.06 0 0 0 .019.044l.086.086a.095.095 0 0 1 0 .135l-.194.193a.095.095 0 0 1-.134 0l-.086-.086a.063.063 0 0 0-.09 0"
            fill="#fff"
          />
          <path
            d="M5.064 11.138H1.645a.724.724 0 1 0 0 1.448h3.42a.724.724 0 0 0 0-1.448M16.022.718a.458.458 0 1 0-.647.647l1.112 1.112a.458.458 0 1 0 .647-.647z"
            fill="#E0F8EE"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
        <clipPath id="b">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HpvVaccine
